// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  getSectionListStatus: { data: null },
  createSectionStatus: { data: null },
  editSectionStatus: { data: null },
  deleteSectionStatus: { data: null },
};
